import { Controller, Control, Path, FieldValues } from 'react-hook-form'
import { TextField, Autocomplete } from 'components/Material/index'

interface AutocompleteFieldProps<TField extends FieldValues> {
  control: Control<TField>
  name: Path<TField>
  options: string[] | []
  placeholder?: string
}

export const AutocompleteFieldSimple = <TField extends FieldValues>(
  props: AutocompleteFieldProps<TField>
) => {
  const { control, options, name } = props

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: 'Campo obrigatório'
      }}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ref } = field
        return (
          <>
            <Autocomplete
              value={value}
              onChange={(event, newValue) => {
                onChange(newValue ? newValue : null)
              }}
              options={options}
              renderInput={(params) => (
                <TextField
                  title={props.placeholder || ''}
                  {...params}
                  error={error ? true : false}
                  helperText={error?.message ?? ''}
                  label={props.placeholder || ''}
                  inputRef={ref}
                />
              )}
            />
          </>
        )
      }}
    />
  )
}
